import { render } from "./FailPage.vue?vue&type=template&id=6eefe78a&scoped=true"
import script from "./FailPage.vue?vue&type=script&lang=js"
export * from "./FailPage.vue?vue&type=script&lang=js"

import "./FailPage.vue?vue&type=style&index=0&id=6eefe78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eefe78a"]])

export default __exports__